// removed by extract-text-webpack-plugin
module.exports = {"Portfolio":"Portfolio__Portfolio___oEXNb","PortfolioActive":"Portfolio__PortfolioActive___3ZMzF","PortfolioHidden":"Portfolio__PortfolioHidden___2cT0u"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResumeBox/Portfolio/Portfolio.css
// module id = 55
// module chunks = 0